import React, { useEffect, useState, useRef } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as MoreIcon } from "../../assets/images/MoreSquare1.svg";
// import { ReactComponent as ChartIcon } from "../../assets/images/Chart1.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPackageByOrganisationId,
  getAllVfAdminReport,
  getCategoryMaster,
  updateSelectedReport,
} from "../../reduxSlices/packageSlice";
import {
  BASE_URL,
  VF_ADMIN_ROLE_ID,
  // dateFormate,
  toastConfig,
} from "../../constants/constant";
import styles from "./ReportPage.module.css";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import TopBar from "../../components/topbar/TopBar";
import { useNavigate } from "react-router-dom";
import { getOrganisationMaster } from "../../reduxSlices/organisationSlice";
import ActionDropdown from "../../components/dropdown/ActionDropdown";
import { toast } from "react-toastify";
import { Service } from "../../services/service";
import CommonDialog from "../../components/dialog/CommonDialog";
import CustomTooltip from "../../components/tooltip/CustomTooltip";
import { removeSlashes, truncateText, reportsOrderList } from "../../helpers/helper";
//import moment from "moment";
import moment from 'moment-timezone';
import NoResultFound from "../../components/noResultFound/NoResultFound";

const service = new Service();

const userTableHeader = [
  { id: "reportName", label: "Report Name", minWidth: 170, align: "left" },
];
const vfAdminTableHeader = [
  { id: "reportName", label: "Report Name", minWidth: 170, align: "left" },
  { id: "organisation", label: "Organisation", minWidth: 170, align: "left" },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

export default function ReportPage() {

  const imgRefArrInd = 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userId, setUserId] = useState(null);
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [recentReportsList, setRecentReportsList] = useState([]);
  const [favouriteReportsList, setFavouriteReportsList] = useState([]);
  const [favReportsList, setFavReportsList] = useState([]);
  const searchParams = localStorage.getItem("searchParams");
  const allPackageByOrganisationId = useSelector(
    (state) => state?.package?.allPackageByOrganisationId
  );
  const [userPackageByOrganisationId, setUserPackageByOrganisationId] =
    useState([]);
  const allVfAdminReport = useSelector(
    (state) => state?.package?.allVfAdminReport
  );
  const loading = useSelector((state) => state.package.loading);
  const headerData = useSelector((state) => state.header);
  const searchInput = headerData.searchInput;
  const organisationValue = headerData.organisationValue;
  const categoryValue = headerData.categoryValue;
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const currentUser = useSelector((state) => state?.user?.currentUser?.data);
  const orgId = currentUser?.organization?.organizationId;
  const currUserId = currentUser?.userId;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const organisationMaster = useSelector(
    (state) => state.organization.organisationMaster
  );
  const categoryMaster = useSelector((state) => state.package.categoryMaster);
  const organisationOptions = organisationMaster?.map(
    (item, i) => item.organizationName
  );

  const columns =
    isVfAdmin && searchParams === "/admin"
      ? vfAdminTableHeader
      : userTableHeader;
  const rows =
    isVfAdmin && searchParams === "/admin"
      ? allVfAdminReport
      : userPackageByOrganisationId;

  console.log("rows<<<<", rows);

  const handleMoreIcon = (event, data) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setUserId(data?.pbReportId);
    setId(data);
    setName(data?.reportDetails?.reportName);
  };

  const handleClick = (data) => {
    var envLastUpdated = data?.envLastUpdated ?? "";
    if (envLastUpdated != "") {
      var timeZone = moment.tz.guess();
      var timeZoneOffset = (new Date(envLastUpdated)).getTimezoneOffset();
      var tmzone = moment.tz.zone(timeZone).abbr(timeZoneOffset);
    }
    const reportTitle = data?.reportDetails?.reportName ?? "Document";
    const reportCategory = data?.reportDetails?.reportCategory ?? "";
    // const envLastUpdated = data?.envLastUpdated ?? "";
    const groupId = data?.groupId ?? "";
    const reportId = data?.pbReportId ?? "";
    const profileId = data?.profileId ?? "";
    if (groupId && reportId && profileId) {
      //add to recently viewed
      var recentReports = localStorage.getItem("recentReports");
      if (recentReports == null)
        localStorage.setItem("recentReports", reportId);
      else {
        var rReports = recentReports.split(",");
        if (!rReports.includes(reportId)) {
          rReports.splice(0, 0, reportId);
          rReports = rReports.slice(0, 3);
          localStorage.setItem("recentReports", rReports.join(","));
        }
      }
      dispatch(
        setHeader({
          page: "powerbi",
          title: "",
          subTitle: "",
        })
      );
      dispatch(updateSelectedReport(data));
      navigate(
        `/reports/${removeSlashes(
          reportTitle
        )}/${groupId}/${reportId}/${profileId}`,
        {
          state: {
            reportCategory: reportCategory,
            envLastUpdated: envLastUpdated,
            timezone: tmzone
          },
        }
      );
    } else {
      toast.warning(
        "The specified report has not been uploaded for the organization.",
        toastConfig
      );
    }
  };

  const getPackageData = async () => {
    if (isVfAdmin && searchParams === "/admin") {
      const obj = {
        searchText: searchInput || "",
        organization: organisationValue || [],
      };
      await dispatch(getAllVfAdminReport(obj));
    } else {
      if (orgId) {
        const obj = {
          searchText: searchInput || "",
          category: categoryValue || [],
          orgId: orgId || "",
        };
        await dispatch(getAllPackageByOrganisationId(obj));
      }
    }
  };

  useEffect(() => {
    if (searchParams === "/admin") {
      dispatch(
        setHeader({
          page: "reports",
          title: "Reports",
          subTitle: "Here is the list of all reports along with their details",
        })
      );
      dispatch(getOrganisationMaster());
    } else {
      dispatch(getCategoryMaster());
    }
  }, []);

  useEffect(() => {
    getPackageData();
  }, [dispatch]);

  useEffect(() => {
    getRecentReports();
  }, [allPackageByOrganisationId]);

  useEffect(() => {
    getFavouriteReports();
  }, [allPackageByOrganisationId]);

  const getPackageDataWithDebounce = debounce(() => {
    getPackageData();
  }, 500);

  const organisationValueDebounceLoadData = useCallback(
    debounce(getPackageDataWithDebounce, 500),
    [organisationValue]
  );

  const categoryValueDebounceLoadData = useCallback(
    debounce(getPackageDataWithDebounce, 500),
    [categoryValue]
  );

  const searchInputDebounceLoadData = useCallback(
    debounce(getPackageDataWithDebounce, 500),
    [searchInput]
  );

  useEffect(() => {
    organisationValueDebounceLoadData();

    return organisationValueDebounceLoadData.cancel;
  }, [organisationValue, organisationValueDebounceLoadData]);

  useEffect(() => {
    categoryValueDebounceLoadData();

    return categoryValueDebounceLoadData.cancel;
  }, [categoryValue, categoryValueDebounceLoadData]);

  useEffect(() => {
    searchInputDebounceLoadData();

    return searchInputDebounceLoadData.cancel;
  }, [searchInput, searchInputDebounceLoadData]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    if (id) {
      console.log("id>>>>>>>", id);
      deleteReport(id);
      setOpen(false);
    }
  };

  const deleteReport = async (id) => {
    let url = `/api/Report/DeleteReport?profileId=${id?.profileId}&groupId=${id?.groupId}&reportId=${id?.pbReportId}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success("Report has been deleted", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getPackageData();
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.message, toastConfig);
    }
  };

  const getFavouriteReports = () => {
    if (allPackageByOrganisationId.length == 0) return;
    getFavReports();
  };

  const getRecentReports = () => {
    if (
      headerData.searchInput.length > 0 ||
      headerData.categoryValue.length != 0
    ) {
      setRecentReportsList([]);
      return;
    }
    if (
      allPackageByOrganisationId?.length == 0 ||
      allPackageByOrganisationId?.reportsData?.length == 0
    )
      return;
    var recentReportIds = localStorage.getItem("recentReports")?.split(",");
    console.log("recentReportIds", recentReportIds);
    if (recentReportIds?.length > 0) {
      var newRecentReportsList = [];
      recentReportIds.forEach((e) => {
        const filterData = allPackageByOrganisationId?.reportsData?.filter(
          (r) => r.pbReportId == e
        )[0];
        if (recentReportIds.includes(filterData?.pbReportId)) {
          newRecentReportsList.push(filterData);
        }
      });
      setRecentReportsList(newRecentReportsList);
    }
  };

  const markAsFavourite = (e, report) => {
    e.stopPropagation();
    var selectedReport = allPackageByOrganisationId.reportsData.filter(
      (e) => e.pbReportId == report.pbReportId
    )[0];
    updateFavReports(selectedReport);
  };

  const updateFavReports = async (report) => {
    if (!currUserId) return;
    let url =
      `${BASE_URL}/api/Report/MarkAsFavourite?reportId=` +
      report?.pbReportId +
      `&userId=` +
      currUserId;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.testGetApi(url, {}, user_token);
      let resp = data;
      console.log("resp", resp);
      if (resp?.data && resp?.status == 200) {
        toast.success("Report details has been updated", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
        getFavouriteReports();
        // setLoader(false);
      } else {
        //  setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      //setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  const getFavReports = async () => {
    if (!currUserId) return;
    let url = `${BASE_URL}/api/Report/GetFavouriteReports?userId=` + currUserId;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let data = await service.testGetApi(url, {}, user_token);
      let resp = data;
      console.log("resp", resp);
      if (resp?.data && resp?.status == 200) {
        setFavReportsList(resp?.data);
        let favList = resp?.data;
        let fReports = allPackageByOrganisationId.reportsData.filter((e) =>
          favList.includes(e.pbReportId)
        );
        setFavouriteReportsList(fReports);
        let allReports = allPackageByOrganisationId.reportsData.filter(
          (e) => !favList.includes(e.pbReportId)
        );
        setUserPackageByOrganisationId(allReports);
      } else {
        //  setLoader(false);
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      //setLoader(false);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <Paper
        style={{
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "12px",
          boxShadow: "none",
          paddingBottom: "32px",
        }}
      >
        <TopBar
          //  style={{
          //     marginRight:`1%`
          // }}
          isVfAdmin={isVfAdmin}
          searchParams={searchParams}
          organisationFilter={organisationOptions}
          categoryFilter={categoryMaster}
          placeholder="Search reports here..."
        />

        {loading && rows?.length === 0 ? (
          <ContentLoader />
        ) : (
          <TableContainer
            style={{
              maxHeight: `calc(100vh - 320px)`,
              // width: `99%`
            }}
            className="table_container"
          >
            {isVfAdmin && searchParams === "/admin" ? (
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns?.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{
                          minWidth: column.minWidth,
                          backgroundColor: "#fff",
                          color: "#8a8a8a",
                          fontFamily: "Montserrat",
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.length > 0 ? (
                    <>
                      {rows?.map((elem, i) => (
                        <TableRow hover key={i}>
                          <TableCell
                            style={{
                              borderColor: "#f2f4f9",
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              color: "#282828",
                              fontWeight: 600,
                            }}
                          >
                            {elem?.reportDetails?.reportName || "-"}
                          </TableCell>
                          <TableCell
                            style={{
                              borderColor: "#f2f4f9",
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            {elem?.organization?.organizationName || "-"}
                          </TableCell>
                          <TableCell
                            style={{
                              borderColor: "#f2f4f9",
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                            align="center"
                          >
                            <MoreIcon
                              onClick={(e) => handleMoreIcon(e, elem)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                      <ActionDropdown
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        editNavigate={`/edit-report/${userId}`}
                        setOpen={setOpen}
                        isDelete={true}
                        text={"Delete"}
                      />
                    </>
                  ) : (
                    <NoResultFound
                      description="We couldn’t find any matches for search query or applied filter. Please try different
                    keyword or filters."
                    />
                  )}
                </TableBody>
              </Table>
            ) : (
              <>
                {favouriteReportsList?.length > 0 ? (
                  <>
                    <p className={styles.reportHeading}>Favourite Reports</p>
                    <div className={styles.recentDiv}>
                      <>
                        {favouriteReportsList?.map((elem, i) => (
                          <div
                            className={styles.parentDiv}
                            onClick={() => handleClick(elem)}
                          >
                                                            {elem?.pbReportId != null && (
                                  <CustomTooltip
                                    title={
                                      !favReportsList.includes(elem?.pbReportId)
                                        ? "Mark as Favourite"
                                        : "Remove from Favourites"
                                    }
                                    placement="bottom"
                                  >
                                    {!favReportsList.includes(
                                      elem?.pbReportId
                                    ) ? (
                                      <img
                                        alt=""
                                        onClick={(e) =>
                                          markAsFavourite(e, elem)
                                        }
                                        className={styles.favicon}
                                        src={
                                          require(`../../assets/images/Mark-Favourite.svg`)
                                            .default
                                        }
                                      />
                                    ) : (
                                      <img
                                        alt=""
                                        onClick={(e) =>
                                          markAsFavourite(e, elem)
                                        }
                                        className={styles.favicon}
                                        src={
                                          require(`../../assets/images/Is-Favourite.svg`)
                                            .default
                                        }
                                      />
                                    )}
                                  </CustomTooltip>
                                )}
                            <div className={styles.cardContainer}>
                              <div className={styles.firstChildDiv}>
                                {elem?.reportDetails?.reportCategory == null ? (
                                  <img
                                    alt=""
                                    className={styles.reporticon}
                                    src={
                                      require(`../../assets/images/Chart1b.svg`)
                                        .default
                                    }
                                  />
                                ) : (
                                  <div>
                                    <img
                                      alt=""
                                      className={styles.reporticon}
                                      src={require(`../../assets/images/${elem?.reportDetails?.categoryIconName}.png`)}
                                    />
                                    <img
                                      alt=""
                                      className={styles.reporticongif}
                                      src={require(`../../assets/images/${elem?.reportDetails?.categoryIconName}.gif`)}
                                    />
                                  </div>
                                )}
                                {/* <ChartIcon /> */}
                                <div className={styles.acquisitonRetention1}>
                                  {elem?.reportDetails?.reportName || "-"}
                                </div>
                              </div>
                              <div className={styles.fundraising}>
                                {/* <CustomTooltip
                                title={elem?.reportDetails?.reportCategory}
                                placement="bottom"
                              >
                                {truncateText(
                                  elem?.reportDetails?.reportCategory || "",
                                  20
                                )}
                              </CustomTooltip> */}

                                {elem?.reportDetails?.reportCategory || ""}
                              </div>
                              {/* <div className={styles.lastUpdatedSep1}>
                            Last Updated{" "}
                            {elem?.envLastUpdated
                              ? moment(elem?.envLastUpdated).format(dateFormate)
                              : "--"}
                          </div> */}
                            </div>
                          </div>
                        ))}
                      </>
                    </div>
                  </>
                ) : null}

                {recentReportsList?.length > 0 ? (
                  <>
                    <p className={styles.reportHeading}>
                      Recently Viewed Reports
                    </p>
                    <div className={styles.recentDiv}>
                      <>
                        {recentReportsList?.map((elem, i) => (
                          <div
                            className={styles.parentDiv}
                            onClick={() => handleClick(elem)}
                          >
                            <div className={styles.cardContainer}>
                              <div className={styles.firstChildDiv}>
                                {elem?.reportDetails?.reportCategory == null ? (
                                  <img
                                    alt=""
                                    className={styles.reporticon}
                                    src={
                                      require(`../../assets/images/Chart1b.svg`)
                                        .default
                                    }
                                  />
                                ) : (
                                  <div>
                                    <img
                                      alt=""
                                      className={styles.reporticon}
                                      src={require(`../../assets/images/${elem?.reportDetails?.categoryIconName}.png`)}
                                    />
                                    <img
                                      alt=""
                                      className={styles.reporticongif}
                                      src={require(`../../assets/images/${elem?.reportDetails?.categoryIconName}.gif`)}
                                    />
                                  </div>
                                )}
                                {/* <ChartIcon /> */}
                                <div className={styles.acquisitonRetention1}>
                                  {elem?.reportDetails?.reportName || "-"}
                                </div>
                              </div>
                              <div className={styles.fundraising}>
                                {/* <CustomTooltip
                                  title={elem?.reportDetails?.reportCategory}
                                  placement="bottom"
                                >
                                  {truncateText(
                                    elem?.reportDetails?.reportCategory || "",
                                    20
                                  )}
                                </CustomTooltip> */}
                                {elem?.reportDetails?.reportCategory || ""}
                              </div>
                              {/* <div className={styles.lastUpdatedSep1}>
                              Last Updated{" "}
                              {elem?.envLastUpdated
                                ? moment(elem?.envLastUpdated).format(dateFormate)
                                : "--"}
                            </div> */}
                            </div>
                          </div>
                        ))}
                      </>
                    </div>
                  </>
                ) : null}

                {categoryMaster?.length > 0 && rows?.length > 0
                  ? categoryMaster?.map((celem, i) => {
                    let catReportList = rows?.filter(
                      (r) => r.reportDetails?.reportCategory == celem
                    );
                    catReportList = catReportList.sort((a, b) =>
                      a.reportDetails?.reportName.localeCompare(
                        b.reportDetails?.reportName
                      )
                    );
                    // let overviewIndex = catReportList.findIndex(
                    //   (e) =>
                    //     e.reportDetails?.reportName ==
                    //     "Overall Performance Trends" ||
                    //     e.reportDetails?.reportName == "Performance Overview"
                    // );
                    // if (overviewIndex > -1) {
                    //   let overViewElm = catReportList.at(overviewIndex);
                    //   catReportList.splice(overviewIndex, 1);
                    //   catReportList.splice(0, 0, overViewElm);
                    // }
                    catReportList.sort((a, b) => {
                      const order = reportsOrderList.find(c => c.key === a.reportDetails?.reportCategory)?.value || [];

                      const indexA = order.indexOf(a.reportDetails?.reportName);
                      const indexB = order.indexOf(b.reportDetails?.reportName);

                      if (indexA > -1 && indexB > -1) return indexA - indexB;
                      if (indexA > -1) return -1;
                      if (indexB > -1) return 1;
                      return 0;
                    });

                    return catReportList?.length > 0 ? (
                      <>
                        <p className={styles.reportHeading}>{celem}</p>
                        <div className={styles.mainDiv}>
                          {catReportList?.map((elem, j) => (
                            <div
                              style={{ height: "85px" }}
                              className={styles.parentDiv}
                              onClick={() => handleClick(elem)}
                            >
                                                              <div
                                  style={{ marginTop: 0 }}
                                  className={styles.fundraising}
                                >
                                  {/* <CustomTooltip
                                  title={elem?.reportDetails?.reportCategory}
                                  placement="bottom"
                                >
                                  {truncateText(
                                    elem?.reportDetails?.reportCategory || "",
                                    20
                                  )}
                                </CustomTooltip> */}
                                  {/* {elem?.reportDetails?.reportCategory || ""} */}
                                  {elem?.pbReportId != null && (
                                    <CustomTooltip
                                      title={
                                        !favReportsList.includes(
                                          elem?.pbReportId
                                        )
                                          ? "Mark as Favourite"
                                          : "Remove from Favourites"
                                      }
                                      placement="bottom"
                                    >
                                      {!favReportsList.includes(
                                        elem?.pbReportId
                                      ) ? (
                                        <img
                                          alt=""
                                          onClick={(e) =>
                                            markAsFavourite(e, elem)
                                          }
                                          className={styles.favicon}
                                          src={
                                            require(`../../assets/images/Mark-Favourite.svg`)
                                              .default
                                          }
                                        />
                                      ) : (
                                        <img
                                          alt=""
                                          onClick={(e) =>
                                            markAsFavourite(e, elem)
                                          }
                                          className={styles.favicon}
                                          src={
                                            require(`../../assets/images/Is-Favourite.svg`)
                                              .default
                                          }
                                        />
                                      )}
                                    </CustomTooltip>
                                  )}
                                </div>
                              <div className={styles.cardContainer}>

                                <div
                                  style={{ marginBottom: 0 }}
                                  className={styles.firstChildDiv}
                                >
                                  {elem?.reportDetails?.reportCategory ==
                                    null ? (
                                    <img
                                      alt=""
                                      className={styles.reporticon}
                                      src={
                                        require(`../../assets/images/Chart1b.svg`)
                                          .default
                                      }
                                    />
                                  ) : (
                                    <div>
                                      <img
                                        id="iconimg"
                                        alt=""
                                        className={styles.reporticon}
                                        src={require(`../../assets/images/${elem?.reportDetails?.categoryIconName}.png`)}
                                      />
                                      <img
                                        id="iconimg"
                                        alt=""
                                        className={styles.reporticongif}
                                        src={require(`../../assets/images/${elem?.reportDetails?.categoryIconName}.gif`)}
                                      />
                                    </div>
                                  )}
                                  {/* <ChartIcon /> */}
                                  <div
                                    className={styles.acquisitonRetention1}
                                  >
                                    {elem?.reportDetails?.reportName || "-"}
                                  </div>
                                </div>
                                {/* <div className={styles.lastUpdatedSep1}>
                              Last Updated{" "}
                              {elem?.envLastUpdated
                                ? moment(elem?.envLastUpdated).format(dateFormate)
                                : "--"}
                            </div> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    ) : null;
                  })
                  : null}
              </>
            )}
          </TableContainer>
        )}
      </Paper>
      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleDelete}
        title="Confirm delete"
        subTitle={`Are you sure you want to delete <span style="font-weight: 700;">${name}</span> as a report? You’ll not be able to reverse this action.`}
        leftButtonText="Cancel"
        rightButtonText="Delete"
      />
    </>
  );
}
